import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValues = {
  type: '',
  initials: '',
  description: '',
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const RegisterCertificationInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValues}>
      <Outlet />
    </FilterTableProvider>
  );
};

RegisterCertificationInitializer.displayName = 'Page register certification initializer component';

export default RegisterCertificationInitializer;
